module.exports = __webpack_public_path__ + "img/bingomanagerLogo.0391a4db.png";